import {default as lightFactory} from 'whiteLabels/dealsuite/theme/light/theme';
import utils from 'helpers/utils'

const themeOverrides = {};

export default function factory (overrides) {
  const lightOverrides = lightFactory(overrides);
  return utils.mergeObjects(lightOverrides, themeOverrides, true);
}
